<div class="list-view" [ngClass]="addCustomClass()">

  <div class="list-view__header">
    <div class="list-view__header--left">
      <h3 class="list-view__header__title">
        {{title}}
      </h3>
    </div>
    <div class="list-view__header--right">
      <div class="list-view__header__filters">
        @if (filtersExist) {
          <div class="list-view__header__filters__indicator"></div>
        }
        <mat-expansion-panel class="list-view__header__filters__panel"
          (opened)="isFilterPanelOpened = true"
          (closed)="isFilterPanelOpened = false"
          >
          <mat-expansion-panel-header id="filtersHeader">
            <mat-panel-title>
              {{'Filter by' | translate}}
            </mat-panel-title>
            @if (isFilterPanelOpened) {
              <mat-panel-description>
                <button [disabled]="!filtersExist"
                  (click)="clearFilters()"
                  mat-button
                  type="button"
                  id="clearFilters"
                  >
                  {{'Clear filters' | translate}}
                </button>
              </mat-panel-description>
            }
          </mat-expansion-panel-header>
          <ng-content select="filters"></ng-content>
        </mat-expansion-panel>

        <div class="list-view__header__filters__list">
          @for (filter of filtersList; track filter) {
            @if (filter.filterValues?.length) {
              <span class="list-view__header__filters__list__name">
                {{filter.filterName | async}} @if (filter.symbol) {
                <span>[{{filter.symbol}}]</span>
              }
            </span>
            <span class="list-view__header__filters__list__values">
              @for (value of filter.filterValues; track value) {
                <span class="list-view__header__filters__list__values--value"
                  >
                  {{value | async}}
                </span>
              }
            </span>
          }
        }
      </div>
    </div>
    <div class="list-view__header__actions">
      <button [disabled]="!filtersExist"
        (click)="clearFilters()"
        mat-button
        type="button"
        >
        {{'Clear filters' | translate}}
      </button>
      @if (canAdd) {
        <button
          (click)="add()"
          mat-button
          class="list-view__header__add"
          type="button" id="add_new"
          [matTooltip]="'Add new' | translate"
          >
          <mat-icon>add</mat-icon>
        </button>
      }
      <button (click)="selectDisplayedColumns()"
        mat-button
        type="button" id="settings"
        [matTooltip]="'Settings: select displayed columns' | translate"
        >
        <mat-icon>settings</mat-icon>
      </button>
    </div>
  </div>
</div>


<div class="list-view--bottom">

  <div class="list-view__export">
    @if (!bulkOperationsActive && withCheckBoxes) {
      <button
        (click)="toggleBulkOperations()"
        mat-icon-button id="activate_bulk_operations"
        [matTooltip]="'Activate bulk operations checkboxes' | translate"
        type="button"
        >
        <img alt="logo" width="25" src="assets/icons/library_add_check-white-18dp.svg">
      </button>
    }
    @if (bulkOperationsActive && withCheckBoxes) {
      <button
        (click)="toggleBulkOperations()"
        mat-icon-button id="deactivate_bulk_operations"
        [matTooltip]="'Deactivate bulk operations checkboxes' | translate"
        type="button"
        >
        <img alt="logo" width="25" src="assets/icons/library_add_check-black-18dp.svg">
      </button>
    }
    @if (dataSource?.length) {
      <button
        mat-icon-button
        [matMenuTriggerFor]="matMenuExp"
        [matTooltip]="'Export' | translate"
        type="button" id="export_list"
        >
        <mat-icon>save_alt</mat-icon>
      </button>
    }
    @if (withImportEnabled && permissionService.hasPermission(importPermission) | async) {
      <button
        mat-icon-button
        [matTooltip]="'Import' | translate"
        type="button" id="import_top"
        (click)="triggerImport()"
        >
        <mat-icon>upload_file</mat-icon>
      </button>
    }
    @if (permissionService.hasPermission(customAttributeProps?.editAttributesPermission) | async) {
      <button
        (click)="openCustomAttributes()"
        mat-button
        type="button"
        id="customAttributes"
        >
        {{customAttributeProps.editAttributesLinkName}}
      </button>
    }

    <mat-menu #matMenuExp="matMenu">
      <button mat-menu-item (click)="exportExcel()" type="button" id="xlsx">xlsx</button>
      <button mat-menu-item (click)="exportCsv()" type="button" id="csv">csv</button>
    </mat-menu>
    @if (hasMap && dataSource?.length && (permissionService.hasPermission('GOOGLE_MAPS') | async)) {
      <button
        (click)="showMap()" id="show_map"
        mat-icon-button
        [matTooltip]="'Map' | translate"
        type="button"
        >
        <img alt="logo" width="50" src="assets/images/map.png">
      </button>
    }
    @if (selectedItemsCount>0) {
      <button
        mat-button id="bulk_operations"
        [matMenuTriggerFor]="menu"
        class="bulk-operations"
        type="button"
        >
        <span class="material-icons">
          assistant
        </span>{{'Bulk Operations' | translate}}
      </button>
    }
    <mat-menu #menu="matMenu">

      @for (operation of bulkOperationsDefinitions; track operation; let i = $index) {
        <button
          (click)="bulkOperation(operation.type)" id="{{operation.type}}-{{i}}"
          mat-menu-item
          [matTooltip]="selectedItemsCount + ' records selected'  | translate"
          type="button"
        >{{ operation.label | async }}</button>
      }

    </mat-menu>
  </div>

  <mat-paginator [length]="resultsLength"
    [pageSizeOptions]="[10, 50, 100]"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [showFirstLastButtons]="true"
    (page)="loadItems(false, $event)"
  ></mat-paginator>
</div>

<div class="list-view__table" cdkScrollable #scrollable (scroll)="updateRightmostScrollStatus()">

  @if (showSelectAllContainer) {
    @if (showSelectAllItems) {
      <p>{{txtAllPageRecordsSelected}}<a mat-button color="primary" (click)="selectAllRecords()">{{txtSelectAllRecords}}</a></p>
    }
    @if (showClearAllItems) {
      <p>{{txtAllRecordsSelected}}
        <a mat-button color="primary" (click)="deselectAllRecords()">{{'Clear selection' | translate}}  </a>
      </p>
    }
  }
  <mat-table [dataSource]="dataSource" matSort (matSortChange)="matSortChanged($event)"
    cdkDropListOrientation="horizontal"
    cdkDropList
    (cdkDropListDropped)="dropHeader($event)"
    cdkDropListLockAxis="x"
    [multiTemplateDataRows]="isExpandRowAvailable">


    @for (column of columns; track column) {
      <ng-container
        [cdkColumnDef]="column.columnDef">
        @if (column.columnDef === 'checkbox') {
          <mat-header-cell *cdkHeaderCellDef >
            <mat-checkbox (change)="onCheckBoxHeaderChange($event)"
              [checked]="selection.hasValue() && areAllItemsSelected()"
              [indeterminate]="selection.hasValue() && !areAllItemsSelected()"
              >
            </mat-checkbox>
          </mat-header-cell>
        } @else {
          <mat-header-cell *cdkHeaderCellDef mat-sort-header [disabled]="!column.sortable" disableClear
            cdkDrag>
            {{column.header | async}}
            <div class="header-drag-placeholder" *cdkDragPlaceholder></div>
          </mat-header-cell>
        }
        @if (column.columnDef === 'thumbnail') {
          <mat-cell *cdkCellDef="let row" class="list-view__table__cell clickable">
            @if (column.cell(row)) {
              <img
                [src]="column.cell(row) + '?' + cacheBuster"
                [alt]="row.name"
                (click)="onThumbnailClick(row.name)"
                style="width: 75px; height: 75px; " />
            }
          </mat-cell>
        } @else if (column.columnDef === 'checkbox') {
          <mat-cell *cdkCellDef="let row" class="list-view__table__cell" matTooltipClass="allow-cr">
            <mat-checkbox (click)="$event.stopPropagation()"
              (change)="onCheckBoxChange($event, row)"
              [checked]="selection.isSelected(row)"
              >
            </mat-checkbox>
          </mat-cell>
        } @else {
          <mat-cell *cdkCellDef="let row" [matTooltip]="column.tooltip && column.tooltip(row) ? column.tooltip(row) : null"
            [matTooltipClass]="column.tooltipClass ? column.tooltipClass : ''"
            class="list-view__table__cell" matTooltipClass="allow-cr">
            @if (column?.type === 'link') {
              @if (notEmpty(cellValue(column, row))) {
                <a class="link"
                  mat-button
                  [href]="addHttpProtocol(cellValue(column, row))"
                  target="_blank"
                  [title]="cellValue(column, row)">
                  <span style="max-width: 300px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;">
                    {{cellValue(column, row)}}
                  </span>
                </a>
              }
            }
            @if (column?.type === 'color') {
              <div class="color-box" [style.background-color]="'#' + cellValue(column, row)">#{{cellValue(column, row)}}</div>
            }
            @if (column?.type === 'status') {
              <app-status [statusText]="cellValue(column, row)"></app-status>
            }
            @if (column?.type === 'activeVisitStatus') {
              <app-status [statusText]="cellValue(column, row)" [statusField]="'activeVisit'"></app-status>
            }
            @if (column?.type === 'clickable') {
              <span (click)="onClickable(row)" class="clickable">
                {{isNil(cellValue(column, row)) ? '' : cellValue(column, row) | translate}}
              </span>
            }
            @if (column?.type === 'icon') {
              <ng-container *ngTemplateOutlet="iconTemplate; context: {row: row, column: column}"></ng-container>
            }
            @if (column?.type === null || column?.type === undefined || column?.type === 'text' || column?.type === 'number' || column?.type === 'date' || column?.type === 'datetime'|| column?.type === 'time') {
              <span [style]="'color: ' + getColor(column, row)">
                {{isNil(cellValue(column, row)) ? '' : cellValue(column, row).toString() | translate}}
              </span>
            }
          </mat-cell>
        }
      </ng-container>
    }


    @if (areActionsAvailable) {
      <ng-container
        matColumnDef="actions"
        stickyEnd>
        <mat-header-cell class="list-view__table__actions-header" *matHeaderCellDef>
          {{'Actions' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let row"
          class="list-view__table__actions"
          [class.list-view__table__actions--no-shadow]="atRightmostScroll">
          <ng-container *ngTemplateOutlet="actionsTemplate; context: {$implicit: row}"></ng-container>
        </mat-cell>
      </ng-container>
    }

    @if (isExpandRowAvailable) {
      <ng-container matColumnDef="expand" stickyEnd>
        <mat-header-cell class="list-view__table__expand-header" *matHeaderCellDef>&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let element"
          class="list-view__table__expand"
          [class.list-view__table__expand--no-shadow]="atRightmostScroll">
          @if (element.isExpandRow !== false) {
            <button mat-icon-button aria-label="expand row" (click)="onClickRow(element); $event.stopPropagation()">
              @if (expandedElement !== element) {
                <mat-icon>keyboard_arrow_down</mat-icon>
              }
              @if (expandedElement === element) {
                <mat-icon>keyboard_arrow_up</mat-icon>
              }
            </button>
          }
        </mat-cell>
      </ng-container>
    }

    @if (isExpandRowAvailable) {
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let row"
          [attr.colspan]="displayedColumns.length"
          class="list-view__table__expand-row__cell"
          [class.list-view__table__expand-row__cell__active]="expandedElement === row">
          <div class="list-view__table__expand-row__cell__detail" [@detailExpand]="row === expandedElement ? 'expanded' : 'collapsed'">
            <ng-container *ngTemplateOutlet="expandTemplate; context: {$implicit: row}"></ng-container>
          </div>
        </td>
      </ng-container>
    }

    <mat-header-row *matHeaderRowDef="displayedColumns$ | async"></mat-header-row>
    @if (isExpandRowAvailable) {
      <mat-row *matRowDef="let row; columns: displayedColumns$ | async;"
        class="list-view__table__row"
        [class.list-view__table__row-expanded]="expandedElement === row"
        [class.clickable]="row.isExpandRow !== false"
        (click)="row.isExpandRow !== false && onClickRow(row);">
      </mat-row>
      <mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="list-view__table__expand-row"></mat-row>
    } @else {
      <mat-row *matRowDef="let row; columns: displayedColumns$ | async;"></mat-row>
    }
  </mat-table>
</div>
<div class="list-view--bottom">

  <div class="list-view__export">
    @if (dataSource?.length) {
      <button
        mat-icon-button
        [matMenuTriggerFor]="matMenuExp"
        [matTooltip]="'Export' | translate"
        type="button"
        >
        <mat-icon>save_alt</mat-icon>
      </button>
    }
    @if (withImportEnabled && permissionService.hasPermission(importPermission) | async) {
      <button
        mat-icon-button
        [matTooltip]="'Import' | translate"
        type="button" id="import_bottom"
        (click)="triggerImport()"
        >
        <mat-icon>upload_file</mat-icon>
      </button>
    }
    <mat-menu #matMenuExp="matMenu">
      <button mat-menu-item (click)="exportExcel()" type="button">xlsx</button>
      <button mat-menu-item (click)="exportCsv()" type="button">csv</button>
    </mat-menu>
    @if (hasMap && dataSource?.length && (permissionService.hasPermission('GOOGLE_MAPS') | async)) {
      <button
        (click)="showMap()"
        mat-icon-button
        [matTooltip]="'Map' | translate"
        type="button"
        >
        <img alt="logo" width="50" src="assets/images/map.png">
      </button>
    }
    @if (selectedItemsCount>0) {
      <button
        mat-button
        [matMenuTriggerFor]="menu"
        class="bulk-operations"
        type="button"
        >
        <span class="material-icons">
          assistant
        </span>{{'Bulk Operations' | translate}}
      </button>
    }
    <mat-menu #menu="matMenu">

      @for (operation of bulkOperationsDefinitions; track operation) {
        <button
          (click)="bulkOperation(operation.type)"
          mat-menu-item
          [matTooltip]="selectedItemsCount + ' records selected'  | translate"
          type="button"
        >{{ operation.label | async }}</button>
      }

    </mat-menu>
  </div>

  <mat-paginator [length]="resultsLength"
    [pageSizeOptions]="[10, 50, 100]"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [showFirstLastButtons]="true"
    (page)="loadItems(false, $event)"
  ></mat-paginator>
</div>

</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
